module.exports = __webpack_public_path__ + "img/icon-darkness-ax.ed06be0d.svg";